import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Follow a user
export const followUser = async (followingId) => {
  const response = await api.post('/followers/follow', { followingId });
  return response.data;
};

// Unfollow a user
export const unfollowUser = async (followingId) => {
  const response = await api.delete(`/followers/unfollow/${followingId}`);
  return response.data;
};

// Get users the current user is following
export const getFollowing = async (userId = null) => {
  const url = userId ? `/followers/following/${userId}` : '/followers/following';
  const response = await api.get(url);
  return response.data;
};

// Get users who follow the current user
export const getFollowers = async (userId = null) => {
  const url = userId ? `/followers/followers/${userId}` : '/followers/followers';
  const response = await api.get(url);
  return response.data;
};

// Check if the current user is following a specific user
export const checkFollowStatus = async (followingId) => {
  const response = await api.get(`/followers/check-follow/${followingId}`);
  return response.data;
};

// Get follower and following counts
export const getFollowCounts = async (userId = null) => {
  const url = userId ? `/followers/counts/${userId}` : '/followers/counts';
  const response = await api.get(url);
  return response.data;
};